

























import { Component, Vue, Prop } from 'vue-property-decorator';

import PhoneMockupIcon from '@/components/icons/PhoneMockup.vue';

@Component({
  components: {
    PhoneMockupIcon
  }
})
export default class PhoneMockup extends Vue {
  @Prop({ default: '266' }) width?: string;
  @Prop() disabledScroll?: boolean;
}
